import ApiConstants from '../constants/ApiConstants';
import { PROFILE_STAGES_CONSTANT } from '../constants/Constant';
import http from "../http";
import TenantManager from '../managers/TenantManager';
import { TENANT, TenantService } from '../managers/TenantManagerService';

class ProfileSetupService {

    static updateStateOfProfileStage(stage) {
        let profileStages;
        let service;

        if (TenantService.get(TENANT.IS_ADMIN)) {
            profileStages = TenantManager.getProfileData();
            service = ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.TENANT;
        } else {
            profileStages = TenantService.get(TENANT.EMPLOYEE_PROFILE_STAGES);
            
            if(stage === PROFILE_STAGES_CONSTANT.FILLING_AUTH) {
                profileStages[PROFILE_STAGES_CONSTANT.FILLING_AUTH] = false;
            }
            service = ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.USERS;
        }

        if (profileStages[stage]) {
            return Promise.resolve({ profileStages: profileStages });
        }

        return http.put(service + '/profile/' + stage);
    }
}

export default ProfileSetupService;
